"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Utils_1 = __importDefault(require("./Utils"));

var Controller =
/** @class */
function () {
  function Controller() {}

  Controller.prototype.setUrl = function (url) {
    this.url = url;
  };

  Controller.prototype.getUrl = function () {
    return this.url;
  };

  Controller.prototype.saveToken = function (token, owner) {
    switch (owner) {
      case "company":
        window.localStorage.setItem("company_token", token);
        this.companyToken = token;
        break;

      case "user":
        window.localStorage.setItem("user_token", token);
        this.userToken = token;
        break;

      default:
        console.error("Did you forget to set the token owner");
        return;
    }
  };

  Controller.prototype.getToken = function (owner) {
    switch (owner) {
      case "company":
        // if (!this.companyToken) {
        //   this.companyToken = window.localStorage.getItem("company_token");
        // }
        try {
          return window.localStorage.getItem("company_token") || this.companyToken || null;
        } catch (err) {
          return null;
        }

      case "user":
        // if (!this.userToken) {
        //   this.userToken = window.localStorage.getItem("user_token");
        // }
        try {
          return window.localStorage.getItem("user_token") || this.userToken || null;
        } catch (err) {
          return null;
        }

    }
  };

  Controller.prototype.getTokenPayload = function (owner) {
    var token = "";
    token = this.getToken(owner);
    if (!token) return;
    return Utils_1.default.JWT.getJWTPayload(token);
  };

  Controller.prototype.isLoggedIn = function (owner) {
    switch (owner) {
      case "company":
        var company = this.getTokenPayload(owner);

        if (company) {
          return company.exp > Date.now() / 1000;
        }

        return false;

      case "user":
        var user = this.getTokenPayload(owner);

        if (user) {
          return user.exp > Date.now() / 1000;
        }

        return false;
    }
  };

  Controller.prototype.deleteUserToken = function () {
    this.userToken = null;
    window.localStorage.removeItem("user_token");
  };

  Controller.prototype.deleteTokens = function () {
    this.userToken = null;
    this.companyToken = null;
    window.localStorage.removeItem("user_token");
    window.localStorage.removeItem("company_token");
  };

  return Controller;
}();

exports.default = Controller;